import classNames from 'classnames';
import Link from 'next/link';
import React, { memo } from 'react';

import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { getPartnerNewsLink, sliceOrganizationName } from '../../../../helpers/news';
import { IMaterial } from '../../../../interfaces/news';

import styles from './article-header.module.scss';

export const PartnerLabel = memo(
  ({ organizationData, className }: { organizationData: IMaterial['organizationData']; className?: string }) => {
    const isMobile = useIsMobile();

    if (!organizationData) return null;

    const slicedName = sliceOrganizationName(organizationData.name);
    const { type, alias } = organizationData;

    const linkProps = getPartnerNewsLink(type, alias);

    return (
      <Typography.Text size={10} strong uppercase>
        <Link {...linkProps}>
          <div className={classNames(styles.rubric, className)}>
            {organizationData.logotype && (
              <img
                className={styles.rubricIcon}
                width={20}
                height={20}
                src={organizationData.logotype}
                alt={'Логотип партнёра'}
              />
            )}
            <Typography.Link href={linkProps.as} color={'black'}>
              {isMobile ? slicedName : organizationData.name}
            </Typography.Link>
          </div>
        </Link>
      </Typography.Text>
    );
  },
);
